import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/common/GlobalErrorBoundary/.eu';
import Kr from '@di-shared/features/common/GlobalErrorBoundary/.kr';

export interface GlobalErrorBoundaryProps {
  error: Error | null;
}

export default function GlobalErrorBoundary(props: GlobalErrorBoundaryProps) {
  return (
    <>
      <Environment.Eu>
        <Eu {...props} />
      </Environment.Eu>
      <Environment.Kr>
        <Kr {...props} />
      </Environment.Kr>
    </>
  );
}
